module.exports = __webpack_public_path__ + "img/top-ways.605b55a.svg";